import styled, { css } from 'styled-components';
import Typography from '../../../../../styles/Typography';
import { StyledDefaultRadioProps } from '../../types';

export const StyledRadioWrapper = styled.span`
  display: block;
  width: 100%;
`;

export const StyledRadioControlWrapper = styled.span<StyledDefaultRadioProps>`
  width: 100%;
  border-radius: var(--r-md);
  border: 1px solid rgba(0, 0, 0, 0.12);
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.6;
    `}
  min-height: 4.25rem;
`;

export const StyledRadioMark = styled.span<StyledDefaultRadioProps>`
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 100%;
  transition: border 160ms ease;
  ${({ checked }) =>
    checked
      ? css`
          border: 7px solid var(--brand-green);
        `
      : css`
          border: 2px solid rgba(9, 15, 56, 0.38);
        `}
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) =>
    theme.direction === 'rtl'
      ? 'margin-left: 1.75rem;'
      : 'margin-right: 1.75rem;'}
`;

export const StyledRadioLabel = styled(Typography).attrs({
  forwardedAs: 'span',
  variant: 'body',
})`
  display: inline-flex;
  color: var(--ink);
`;

export const StyledRadioInfo = styled(Typography).attrs({
  forwardedAs: 'span',
  variant: 'caption',
})`
  display: block;
  color: var(--muted);
`;

export const StyledRadioInfoWrapper = styled.span`
  display: block;
  width: 100%;
  margin-top: 0.5rem;
  padding-bottom: 0.25rem;
`;

export const StyledRadioDecorWrapper = styled.figure`
  display: inline-flex;
  height: 2.25rem;
  width: 2.25rem;
  flex-shrink: 0;
  border-radius: 100%;
  background-color: var(--surface);
  border: 1px solid rgba(9, 15, 56, 0.15);
  overflow: hidden;
  justify-content: center;
  align-items: center;

  ${({ theme }) =>
    theme.direction === 'rtl' ? 'margin: 0 auto 0 0;' : 'margin: 0 0 0 auto;'}
`;

export const StyledRadioDecor = styled.img`
  height: auto;
  width: 100%;
  max-width: 100%;
  display: block;
`;
